

import React, { useRef } from 'react';
import '../App.css';

import Honor01 from '../img/Cuadro-Honor01.jpg';
import Honor02 from '../img/Primero.jpeg';
import Honor03 from '../img/cuarto.jpeg';
import Honor04 from '../img/kinder.jpeg';
import Honor05 from '../img/Cuadro-Honor02.JPG';

const CuadroHonorComponent = () => {
  const scrollRef = useRef(null);

  const honorData = [
    {
      id: 5,
      date: 'Mejor Asistencia',
      title: 'Mes de Octubre 2025',
      description: 'Reconocimiento a estudiantes con asistencia destacada.',
      imageUrl: Honor05,
      type: 'image',
    },
    {
      id: 1,
      date: 'Mejor Asistencia',
      title: 'Mes de Septiembre 2025',
      description: 'Reconocimiento a estudiantes con asistencia destacada.',
      imageUrl: Honor01,
      type: 'image',
    },
    {
      id: 2,
      date: 'Primer Lugar Campeonato de Cueca Escolar 2025',
      title: '4° Básico: Antonella Castillo y Santiago Rodríguez',
      description: '',
      imageUrl: Honor02,
      type: 'image',
    },
    {
      id: 3,
      date: 'Cuarto Lugar Campeonato de Cueca Escolar 2025',
      title: '6° Básico: Nelsa Zamorano y Máximo Soto',
      description: '',
      imageUrl: Honor03,
      type: 'image',
    },
    {
      id: 4,
      date: 'Campeonato de Cueca Escolar 2025',
      title: 'Kinder: Perla Escolástico y Erick Ellie',
      description: '',
      imageUrl: Honor04,
      type: 'image',
    },
  ];

  const openFileInNewTab = (fileUrl) => {
    window.open(fileUrl, '_blank');
  };

  return (
    <div id="cuadro-honor-component" className="events-component">
      <h2>CUADRO DE HONOR (Doble clic para ampliar)</h2>

      <div className="carousel-container no-arrows">
        <div className="event-cards-container large-cards" ref={scrollRef}>
          {honorData.map((item) => (
            <div key={item.id} className="event-card large-card">
           
              <div className="event-date licenciados-date">{item.date}</div>
              <div className="event-details">
                <h3>{item.title}</h3>
                <p className="event-description">{item.description}</p>
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="honor-image large-image"
                  onDoubleClick={() => openFileInNewTab(item.imageUrl)}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CuadroHonorComponent;
